import { jsx as a } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import m from "classnames";
import t from "./label.module.less.js";
const b = l(function({ className: o, ...r }, s) {
  const e = m(t.label, o);
  return /* @__PURE__ */ a("label", { ...r, className: e, ref: s });
});
export {
  b as Label
};
//# sourceMappingURL=label.js.map
